<template>
  <v-dialog :value="exibirModal" max-width="900" persistent>
    <v-card>
      <v-card-title class="title primary white--text thin" primary-title>
        <span class="thin--span">Selecionar Documentos para Contratação</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="fecharModal" dark>
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pa-4">
        <label-personalizado nome-campo="Documentos Disponíveis"></label-personalizado>

        <v-alert v-if="erro" type="error" outlined class="mb-3">
          {{ erro }}
        </v-alert>

        <v-data-table
          :headers="headers"
          :items="documentos"
          show-select
          item-key="documentoVirtualizadoId"
          v-model="documentosSelecionados"
          :loading="carregando"
          hide-actions
          :no-data-text="'Nenhum documento disponível'"
          class="elevation-0"
        >
          <template slot="headers" slot-scope="props">
            <tr>
              <th class="text-xs-center" style="width: 36px;">
                <v-tooltip top>
                  <template #activator="{ on, attrs }">
                    <v-checkbox
                      v-bind="attrs"
                      v-on="on"
                      :input-value="isAllSelected"
                      :indeterminate="isIndeterminate"
                      @change="onToggleSelectAll"
                      primary
                      hide-details
                      class="ma-0 pa-0"
                    />
                  </template>
                  <span>Selecionar  Todos</span>
                </v-tooltip>
              </th>
              <th class="text-xs-left">Documento</th>
              <th class="text-xs-left">Juntado</th>
              <th class="text-xs-left">Tipo</th>
            </tr>
          </template>

          <template slot="items" slot-scope="props">
            <tr>
              <td class="text-xs-center" style="width: 36px;">
                <v-checkbox
                  v-model="props.selected"
                  primary
                  hide-details
                  class="ma-0 pa-0"
                />
              </td>
              <td>
                {{ props.item && props.item.nome ? props.item.nome : '-' }}
              </td>
              <td>
                {{ formatarBoolean(props.item && props.item.juntado) }}
              </td>
              <td>
                {{ formatarTipo(props.item && props.item.tipo) }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="pa-3">
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" outline @click="fecharModal">
          Cancelar
        </v-btn>
        <v-btn
          color="primary"
          @click="enviar"
          :disabled="!temDocumentosSelecionados"
        >
          Enviar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import LabelPersonalizado from '../../commons/LabelPersonalizado.vue'
import TiposDocumento from '@/commons/constants/tipos-documento-virtualizados'

export default {
  name: 'ModalSelecionarDocumentosDemanda',
  components: {
    LabelPersonalizado
  },
  props: {
    exibirModal: {
      type: Boolean,
      default: false
    },
    credenciamentoId: {
      type: [Number, String],
      required: true
    },
    demandaId: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      documentosSelecionados: [],
      documentos: [],
      itensTabela: [],
      carregando: false,
      erro: null,
      headers: [
        { text: 'Documento', value: 'nome', sortable: false },
        { text: 'Juntado', value: 'juntadoFmt', sortable: false },
        { text: 'Tipo', value: 'tipoFmt', sortable: false }
      ]
    }
  },
  watch: {
    exibirModal: {
      immediate: true,
      handler(novoValor) {
        if (novoValor) {
          this.carregarDocumentos()
        }
      }
    }
  },
  computed: {
    temDocumentosSelecionados() {
      return this.documentosSelecionados.length >= 0
    },
    isAllSelected() {
      const total = (this.documentos || []).length
      return total > 0 && this.documentosSelecionados.length === total
    },
    isIndeterminate() {
      const total = (this.documentos || []).length
      return this.documentosSelecionados.length > 0 && this.documentosSelecionados.length < total
    }
  },
  methods: {
    formatarBoolean(valor) {
      if (valor === true) return 'Sim'
      if (valor === false) return 'Não'
      return '-'
    },
    formatarTipo(codigo) {
      if (!codigo) return '-'
      const chave = String(codigo).trim().toUpperCase()
      const label = (TiposDocumento && TiposDocumento[chave]) || null
      return label || codigo
    },
    montarItensTabela() {
      this.itensTabela = (this.documentos || []).map(doc => ({
        ...doc,
        juntadoFmt: this.formatarBoolean(doc.juntado),
        tipoFmt: this.formatarTipo(doc.tipo)
      }))
    },
    onToggleSelectAll() {
      const total = (this.documentos || []).length
      if (total === 0) {
        this.documentosSelecionados = []
        return
      }
      const deveSelecionarTodos = !(this.documentosSelecionados.length === total)
      this.documentosSelecionados = deveSelecionarTodos ? (this.documentos || []).slice() : []
    },
    async carregarDocumentos() {
      if (this.carregando) return
      this.carregando = true
      this.erro = null
      this.documentosSelecionados = []
      try {
        const actionTypes = (await import('@/commons/constants/action-types')).default
        const resposta = await this.$store.dispatch(actionTypes.CREDENCIAMENTO.DEMANDA.BUSCAR_DOCUMENTOS_CONTRATACAO, {
          credenciamentoId: this.credenciamentoId,
          demandaId: this.demandaId
        })
        const docs = Array.isArray(resposta && resposta.documentos) ? resposta.documentos : []
        this.documentos = docs
        this.montarItensTabela()
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e)
        this.erro = 'Erro ao carregar documentos da contratação'
      } finally {
        this.carregando = false
      }
    },
    fecharModal() {
      this.documentosSelecionados = []
      this.$emit('fechar-modal')
    },
    async enviar() {
      if (!this.temDocumentosSelecionados) return
      try {
        const actionTypes = (await import('@/commons/constants/action-types')).default
        const documentos = (this.documentosSelecionados || []).map(doc => ({
          documentoVirtualizadoId: doc.documentoVirtualizadoId || doc.id || null,
          documentoId: doc.documentoId || null,
          uri: doc.uri || null,
          fornecedorId: doc.fornecedorId || null,
          tipo: doc.tipo || null,
          situacaoDocumento: doc.situacaoDocumento ? String(doc.situacaoDocumento) : (doc.situacaoDocumentoCodigo || null),
          origem: doc.origem ? String(doc.origem) : (doc.origemCodigo || null),
          nome: doc.nome || null,
          fornecedor: doc.fornecedor || doc.razaoSocial || null,
          processoVirtual: doc.processoVirtual || null,
          nomeRepositorio: doc.nomeRepositorio || null,
          tokenRepositorio: doc.tokenRepositorio || null,
          idPastaRepositorio: doc.idPastaRepositorio || null,
          entidadeId: doc.entidadeId || null,
          entidade: doc.entidade || null
        }))

        await this.$store.dispatch(actionTypes.CREDENCIAMENTO.DEMANDA.SALVAR_DOC_DEMANDAS_CREDENCIAMENTO, {
          credenciamentoId: this.credenciamentoId,
          demandaId: this.demandaId,
          documentos
        })

        if (this.$azNotify && typeof this.$azNotify.success === 'function') {
          this.$azNotify.success('Documentos salvos com sucesso!')
        }
        this.$emit('enviar', this.documentosSelecionados)
        this.fecharModal()
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e)
        if (this.$azNotify && typeof this.$azNotify.error === 'function') {
          this.$azNotify.error('Erro ao salvar documentos da demanda.')
        }
      }
    }
  }
}
</script>

<style scoped>
.thin--span {
  font-weight: 300;
}
</style>
